define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var LpAjaxTransport = require('lptransporter/lpajax');
    var PostmessageTransport = require('lptransporter/transports/postmessage');
    var JsonpTransport = require('lptransporter/transports/jsonp');
    var Events = require("Chronos.Events");

    window.lpTag = window.lpTag || {};

//Init the entities scope
    var VisitorFeedApi = function visitorFeedAPI(visitorFeedConfig) {
        if (this === window) {//Must be instantiated with new
            return false;
        }
        //Our public object
        var visitorFeed = this;
        var environmentOptions = {QA : "QA", DEV : "DEV", PRODUCTION : "PRODUCTION"};
        var siteConfig = { domain: "", lpNumber: visitorFeedConfig.lpNumber, environment: environmentOptions.PRODUCTION }; //Contains the basic data we need for the polling: domain, lpNumber
        var QADomain = "qtvr-wap03.dev.lprnd.net";
        var commConfigured = false;
        var baseUri = "";
        var engine, pollingTimeout, isPolling;
        var defaultPollingTimeout = 10000, defaultRetryTimeOut = 2000;
        var retryTimeout = null;
        var errorCount = 0;
        var globalAccessToken = visitorFeedConfig.accessToken;
        var lastQueryParams = {};
        var latestBodyData = {};


        function trim(val) {
            if (typeof val === 'string' && val !== '') {
                val = val.replace(/^[\s*\n*\r*\t\*]$[\s*\n*\r*\t\*]/g, '');
            }
            return val;
        }

        function bindCalls(configuration) {
            for (var key in configuration) {//Auto sign up
                if (configuration.hasOwnProperty(key)) {
                    if (key.indexOf('on') === 0) {
                        if (visitorFeed.hasOwnProperty(key)) {
                            bindCallbacks(configuration[key], key);
                        }
                    }
                }
            }
        }

        function bindCallbacks(bindFuncs, eventName) {
            bindFuncs = bindFuncs.constructor === Array ? bindFuncs : [bindFuncs];
            for (var i = 0; i < bindFuncs.length; i++) {//Bind all required events
                if (typeof bindFuncs[i] === 'function') {
                    visitorFeed[eventName](bindFuncs[i]);
                } else if (typeof bindFuncs[i] === 'object' && bindFuncs[i].callback) {
                    if (typeof bindFuncs[i].callback === 'function') {
                        visitorFeed[eventName](bindFuncs[i].callback, '', (bindFuncs[i].context || null));
                    }
                }
            }
        }

        function isConfigReady() {
            return !!(siteConfig.lpNumber && siteConfig.domain);
        }

        function setSiteConfigParams(configData) {
            if (configData) {
                siteConfig.domain = trim(configData.domain) || trim(siteConfig.domain) || '';
                siteConfig.lpNumber = trim(configData.lpNumber) || trim(configData.site) || trim(siteConfig.lpNumber) || '';
                siteConfig.environment = configData.environment && environmentOptions[configData.environment] ? configData.environment : siteConfig.environment;
            }
        }
        //Generic method for running callbacks
        function runCallback(callback, context, data) {
            if (callback && typeof callback === 'function') {
                try {
                    callback.apply(context || null, [data]);
                } catch (err) {}
            }
            callback = null;
            data = null;
        }

        function setUp() {
            engine = new Events({cloneEventData: false, eventBufferLimit: 50});
            if(visitorFeedConfig){
                setSiteConfigParams(visitorFeedConfig);
                bindCalls(visitorFeedConfig);

                var CSDSRequestObj = {
                    lpNumber: siteConfig.lpNumber,
                    success: function (data) {
                        siteConfig.domain = data.domain;
                        baseUri = "https://" + siteConfig.domain + "/api/account/" + siteConfig.lpNumber + "/visitorfeed/visitors";
                        if (visitorFeedConfig.query) {
                            visitorFeed.updateQuery(visitorFeedConfig.query);
                        }
                        if (visitorFeedConfig.data) {
                            visitorFeed.updateBodyData(visitorFeedConfig.data);
                        }
                        if (visitorFeedConfig.pollingTimeout) {
                            defaultPollingTimeout = visitorFeedConfig.pollingTimeout;
                        }
                        if (visitorFeedConfig.lpNumber && visitorFeedConfig.startPolling) {
                            visitorFeed.startPolling();
                        }
                    },
                    error: function (errorData) {
                    }};

                CSDSRequest(CSDSRequestObj);
            }
        }

        function scheduleNextPolling() {
            if (!isPolling) {
                return;
            }
            if (pollingTimeout) {
                clearTimeout(pollingTimeout);
            }
            pollingTimeout = setTimeout(visitorFeed.startPolling, defaultPollingTimeout);
        }

        function addToEventEngine(eventName, callBack, context) {
            if (!engine) {
                return false;
            }

            var eventInfo = {
                eventName: eventName,
                aSync: false,
                func: callBack,
                context: (context || null)
            };
            return engine.register(eventInfo);
        }

        function unbindFromEvents(eventName, callBack, context) {
            if (!engine) {
                return false;
            }

            if (typeof eventName === 'function') {
                callBack = eventName;
                eventName = "";
            } else if (typeof eventName === 'object') {
                context = eventName;
                eventName = "";
            }

            var eventInfo = {
                eventName: eventName,
                appName: "",
                func: callBack || null,
                context: (context || null)
            };
            return engine.unbind(eventInfo);
        }

        function configurePostMessage() {
            if (siteConfig.domain && !commConfigured) {
                PostmessageTransport.configure({
                    frames : [ { url: "https://" + siteConfig.domain + "/postmessage.min.html", delayLoad: 0, maxReloadRetries: 500, reloadInterval: 10} ]
                });
                commConfigured = true;
            }
            return commConfigured;
        }

        function CSDSRequest(requestObj) {
            if (!requestObj.lpNumber) {
                return false;
            }
            var serviceDomain;
            var visitorFeedApiResource = agentLEManager.getLEUrlResolverApiResourcesService('VisitorFeed');
            if (visitorFeedApiResource) {
                serviceDomain = agentLEManager.getLEUrlResolverGetUrl(visitorFeedApiResource);
            }
            if (serviceDomain) {
                if (serviceDomain.indexOf("https://") !== -1) {
                    serviceDomain = serviceDomain.substring("https://".length);
                }
            } else if (lpTag && lpTag.csds && lpTag.csds.getDomain) {
                serviceDomain = lpTag.csds.getDomain("visitorFeed");
            }
            if (serviceDomain) {
                return runCallback(requestObj.success, requestObj.context, {domain: serviceDomain, site: requestObj.lpNumber});
            }
            if (siteConfig.environment !== environmentOptions.PRODUCTION) {
                return runCallback(requestObj.success, requestObj.context, {domain: QADomain, site: requestObj.lpNumber});
            } else {
                var preRequest = {url: "https://api.liveperson.net/api/account/" + requestObj.lpNumber + "/service/visitorFeed/baseURI.lpCsds?version=1.0"};
                preRequest.success = function (data) {
                    var domain;
                    if (data && data.ResultSet && data.ResultSet.lpData) {
                        var results = data.ResultSet.lpData;
                        for (var i = 0; i < results.length; i++) {
                            if (!domain && results[i].lpServer) {
                                domain = results[i].lpServer;
                            }
                        }
                    }
                    preRequest = null;
                    if (domain) {
                        runCallback(requestObj.success, requestObj.context, {domain: domain, site: requestObj.lpNumber});
                    } else {
                        runCallback(requestObj.error, requestObj.context, {error: "unable to resolve site domain", response: data, site: requestObj.site});
                    }
                };
                preRequest.error = preRequest.success;
                return JsonpTransport.issueCall(preRequest);
            }
        }

        visitorFeed.stopPolling = function (error) {
            visitorFeed.clearPollingData();
            engine.publish({eventName: "onStopPolling", data: { error: error, query: lastQueryParams, data: latestBodyData}});
        };

        visitorFeed.startPolling = function (startRequest) {
            if (isConfigReady() && configurePostMessage()) {
                var request = {
                    url: baseUri,
                    headers: {AUTHORIZATION: 'Bearer ' + globalAccessToken},
                    method: "GET",
                    transportOrder: ["postmessage"],//["websocket2http" , "postmessage"]/******************Temporarily removing WebSockets until Batchelor issues are resolved ********/
                    query: lastQueryParams,
                    success: function (data) {
                        if (data && data.responseCode >= 400) {
                            handleError(visitorFeed.startPolling, request);
                        } else {
                            handleSuccess(startRequest, data);
                            scheduleNextPolling();
                        }
                    },
                    error: function (errorData) {
                        handleError(visitorFeed.startPolling, request);
                    }
                };
                if (lpTag.WebAgent.logicController.hasVisitorFeedQueryFeature()) {
                    request.url = baseUri + "/query";
                    request.method = "POST";
                    request.data = latestBodyData;
                } else if (lpTag.WebAgent.logicController.hasVisitorFeedPreFiltering()) {
                    request.url = baseUri + "/prefilter";
                }
                isPolling = true;
                LpAjaxTransport.issueCall(request);
            } else {
                engine.publish({eventName: "onStartPolling", data: { error: "Visitor Feed domain is not ready yet", query: lastQueryParams, data:latestBodyData}});
            }
        };

        visitorFeed.getVisitorsInfo = function (request) {//TODO: how to make these requests serial and timed (timeout property...)
            if (isConfigReady() && configurePostMessage()) {
                var req = {
                    url: baseUri + (request ? getVidParamsFromArray(request.vid) : ""),
                    success: function (data) {
                        engine.publish({eventName: "onVisitorsInfo", data: data});
                    },
                    error: function (errorData) {
                        engine.publish({eventName: "onVisitorsInfo", data: errorData});
                    }
                };
                getVisitors(req);
            } else {
                engine.publish({eventName: "onVisitorList", data: { error: "Visitor Feed domain is not ready yet", query: lastQueryParams, data: latestBodyData}});
            }
        };

        function getVisitors(request) {
            var req = {
                url: request.url || baseUri,
                headers: {AUTHORIZATION: 'Bearer ' + globalAccessToken},
                method: "GET",
                transportOrder: ["postmessage"],//["websocket2http" , "postmessage"]/******************Temporarily removing WebSockets until Batchelor issues are resolved ********/
                data: request.data,
                success: function (data) {
                    if (data && data.responseCode >= 400) {
                        handleError(getVisitors, req);
                    } else {
                        handleSuccess(request, data);
                    }
                },
                error: function (errorData) {
                    handleError(getVisitors, req);
                }
            };
            LpAjaxTransport.issueCall(req);
        }

        function handleSuccess(request, data) {
            errorCount = 0;
            data = data && data.body ? data.body : data;
            data.visitorsList = data.visitorsList || {count: 0, visitors: []};
            data.visitorsList.visitors = data.visitorsList.visitors || [];
            if (request && request.success) {
                runCallback(request.success, request.context, data);
                return;
            }
            engine.publish({eventName: "onVisitorList", data: data});
        }

        function handleError(retryFunction, retryArg) {
            errorCount = errorCount + 1;
            if (errorCount > 3) {
                var error = 'Visitor Feed Service is not responding to last ' + errorCount + ' calls';
                engine.publish({eventName: "onVisitorList", data: {error : error}});
            }
            if (retryFunction && typeof retryFunction === 'function') {
                if (retryTimeout) {
                    clearTimeout(retryTimeout);
                }
                retryTimeout = setTimeout(
                    function () {
                        runCallback(retryFunction, null, retryArg);
                    }, defaultRetryTimeOut * errorCount);
            }
        }

        function getVidParamsFromArray(vidArray) {
            var queryString = "";
            if (vidArray && vidArray.length) {
                queryString = "?vid=" + encodeURIComponent(vidArray[0]);
                for (var i = 1; i < vidArray.length; i++) {
                    queryString += "&vid=" + encodeURIComponent(vidArray[i]);
                }
            }
            return queryString;
        }

        visitorFeed.clearPollingData = function () {
            errorCount = 0;
            isPolling = false;
            if (pollingTimeout) {
                clearTimeout(pollingTimeout);
            }
            if (retryTimeout) {
                clearTimeout(retryTimeout);
            }
        };

        visitorFeed.getCurrentQuery = function () {
            return lastQueryParams;
        };

        visitorFeed.getCurrentBodyData = function () {
            return latestBodyData;
        };

        visitorFeed.updateQuery = function (queryParams) {
            lastQueryParams = lpUtils.cloneObject(queryParams);
        };

        visitorFeed.updateBodyData = function (bodyData) {
            latestBodyData = lpUtils.cloneObject(bodyData);
        };

        //******************************Event binding *************************************
        visitorFeed.onStartPolling = function (callback, context) {
            addToEventEngine("onStartPolling", callback, context);
        };

        visitorFeed.onStopPolling = function (callback, context) {
            addToEventEngine("onStopPolling", callback, context);
        };

        visitorFeed.onVisitorList = function (callback, context) {
            addToEventEngine("onVisitorList", callback, context);
        };

        visitorFeed.onVisitorsInfo = function (callback, context) {
            addToEventEngine("onVisitorsInfo", callback, context);
        };

        visitorFeed.unbind = function (eventName, callback, context) {
            return unbindFromEvents(eventName, callback, context);
        };

        setUp();

        return visitorFeed;
    };

    return VisitorFeedApi;

});
